import { Stack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

export interface SeparatorProps {
  hasExtraInfo?: boolean;
  noPadding?: boolean;
}

export const Separator: React.FC<SeparatorProps> = ({ hasExtraInfo, noPadding }) => {
  if (hasExtraInfo) {
    return (
      <Stack px={noPadding ? 0 : Spacing['inline.xxs']}>
        <Box w="full" h="16px" bgColor={Color['neutral.white']} />
      </Stack>
    );
  }

  return (
    <Stack px={noPadding ? 0 : Spacing['inline.xxs']}>
      <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
    </Stack>
  );
};

export const MobileSeparator = () => {
  return <Stack py={Spacing['stack.quarck']} />;
};
